import { Menu, MenuItem, Divider } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import FormIcon from '@mui/icons-material/Description';
import BudgetIcon from '@mui/icons-material/AccountBalance';
import BbeeIcon from '@mui/icons-material/Business';
import TrainingIcon from '@mui/icons-material/School';
import MenuIcon from '@mui/icons-material/Menu';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../slices/authSlice";
import { roleType } from "../constant/constants";
import CButton from "./CButton";
import { getCurrentUserRole, getCurrentUserName, isCompanyPrivileged } from "../utils/roleUtils";
import { persistor } from "../store";
import { useSelector } from "react-redux";
import { getLocalData } from "../constant/utils/commonUtils";
import { clearCache } from "../cache/dashboardCache";
import Logo from "../assets/images/logo.png";
function Header({ isMobileSidebarOpen, setIsMobileSidebarOpen }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const open = Boolean(anchorEl);
  const settingsOpen = Boolean(settingsAnchorEl);
  const [role, setRole] = useState(() => getCurrentUserRole());
  const { configData } = useSelector((state) => state.config);

  useEffect(() => {
    const syncRole = () => setRole(getCurrentUserRole());
    syncRole();
    window.addEventListener("sdfUserUpdated", syncRole);
    return () => window.removeEventListener("sdfUserUpdated", syncRole);
  }, []);

  const isTrainingWorkflowEnabled = configData?.training_need_workflow ?? false;
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleSettingsClick = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };
  
  const userName = getCurrentUserName();
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleSettingsClose = () => {
    setSettingsAnchorEl(null);
  };

  const handleLogout = async () => {
    const currentUserId = getLocalData()?.emp_id ?? getLocalData()?.user_id ?? "";
    if (currentUserId) dispatch(clearCache(currentUserId));
    localStorage.clear();
    sessionStorage.removeItem("authSync_reloading");
    await persistor.purge();
    await dispatch(logoutUser());
    navigate("/");
  };

  const handleConfigurationClick = () => {
    navigate("/training-configuration");
    handleSettingsClose();
  };

  const handleFormConfigurationClick = () => {
    navigate("/form-configuration");
    handleSettingsClose();
  };

  const handleBudgetConfigurationClick = () => {
    navigate("/budget-configuration");
    handleSettingsClose();
  };

  const handleBBBudgetConfigurationClick = () => {
    navigate("/bbbee-budget-configuration");
    handleSettingsClose();
  };

  const handleTrainingTypeBudgetConfigurationClick = () => {
    navigate("/training-type-budget-configuration");
    handleSettingsClose();
  };

  const handleTrainingCategoryBudgetConfigurationClick = () => {
    navigate("/training-category-budget-configuration");
    handleSettingsClose();
  };

  const searchParams = new URLSearchParams(location.search);
  const currentView = searchParams.get("view");
  return (
    <>
      <div className="z-[100] sticky top-0 w-full bg-white border-b border-solid border-grey-400 h-[68px] flex md:justify-end justify-between items-center md:px-6 px-3 py-3">
        {/* Mobile Toggle Button - Only visible on mobile (767px and below) */}
        <CButton
          className="!lowercase hover:!bg-transparent !p-0 flex items-center !h-[40px] md:hidden"
          onClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
        >
          <span className="font-[Poppins] w-[40px] h-[40px] rounded-full bg-blue-100 hover:bg-blue-200 text-blue-600 flex items-center justify-center transition-colors">
            <MenuIcon style={{ fontSize: 20 }} />
          </span>
        </CButton>
        <div className="md:hidden block">
          <img
            src={Logo}
            className="w-full max-w-[120px] m-auto transition-all duration-300"
          />
        </div>
        
        <div className="flex items-center md:gap-4 gap-2">
          {/* Settings Menu - Only visible to SDF users */}
          {isCompanyPrivileged(role) &&   isTrainingWorkflowEnabled  && (
            <>
              <CButton
                className="!lowercase hover:!bg-transparent !p-0 flex items-center 2xl:!h-[44px] !h-[40px]"
                onClick={handleSettingsClick}
              >
                <span className="font-[Poppins] 2xl:w-[44px] 2xl:h-[44px] w-[40px] h-[40px] rounded-full bg-blue-100 hover:bg-blue-200 text-blue-600 flex items-center justify-center transition-colors">
                  <SettingsIcon style={{ fontSize: 20 }} />
                </span>
              </CButton>
              <Menu
                id="settings-menu"
                anchorEl={settingsAnchorEl}
                open={settingsOpen}
                onClose={handleSettingsClose}
                MenuListProps={{
                  "aria-labelledby": "settings-button",
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                className="settings-menu-item"
              >
                <MenuItem onClick={handleFormConfigurationClick} className="flex items-center gap-3">
                  <FormIcon style={{ fontSize: 18 }} />
                  <span>Form Configuration</span>
                </MenuItem>
                <MenuItem onClick={handleBudgetConfigurationClick} className="flex items-center gap-3">
                  <BudgetIcon style={{ fontSize: 18 }} />
                  <span>Department Budget</span>
                </MenuItem>
                <MenuItem onClick={handleBBBudgetConfigurationClick} className="flex items-center gap-3">
                  <BbeeIcon style={{ fontSize: 18 }} />
                  <span>B-BBEE Budget</span>
                </MenuItem>
                {/* Training Type Budget Menu - Hidden (can be enabled in future) */}
                {false && (
                <MenuItem onClick={handleTrainingTypeBudgetConfigurationClick} className="flex items-center gap-3">
                  <TrainingIcon style={{ fontSize: 18 }} />
                  <span>Training Type Budget</span>
                </MenuItem>
                )}
                <MenuItem onClick={handleTrainingCategoryBudgetConfigurationClick} className="flex items-center gap-3">
                  <TrainingIcon style={{ fontSize: 18 }} />
                  <span>Training Category Budget</span>
                </MenuItem>
              </Menu>
            </>
          )}

          {/* Help Link */}
          <a
            href="/help.html"
            target="_blank"
            rel="noopener noreferrer"
            title="Help & User Guide"
            className="flex items-center 2xl:h-[44px] h-[40px]"
          >
            <span className="font-[Poppins] 2xl:w-[44px] 2xl:h-[44px] w-[40px] h-[40px] rounded-full bg-blue-100 hover:bg-blue-200 text-blue-600 flex items-center justify-center transition-colors">
              <HelpOutlineIcon style={{ fontSize: 20 }} />
            </span>
          </a>
          
          {/* Profile Menu */}
          <CButton
            className="!lowercase hover:!bg-transparent !p-0 flex items-center 2xl:!h-[44px] !h-[40px]"
            onClick={handleClick}
          >
            <span className="font-[Poppins]  2xl:w-[44px]  2xl:h-[44px] w-[40px]  h-[40px] rounded-full bg-blue-100 text-blue-500 flex items-center justify-center md:text-base md:leading-base text-sm leading-sm font-semibold">
              {userName?.charAt(0).toUpperCase()}
            </span>
            <p className="md:ml-2 ml-0 font-[Poppins] cursor-pointer text-grey-700 font-medium 2xl:text-base 2xl:leading-base md:text-sm md:leading-sm text-xs leading-xs md:block hidden">
              {userName}
            </p>
          </CButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            className="profile-menu-item"
          >
            {/* Profile and Company Setup - Only for SDF & Admin users */}
            {(isCompanyPrivileged(role) || role === roleType.ADMIN) && (
              <>
                <MenuItem
                  onClick={() => {
                    navigate(`/company-setup?view=profile`);
                    handleClose();
                  }}
                  selected={currentView === "profile"}
                >
                  Profile
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate(`/company-setup?view=company`);
                    handleClose();
                  }}
                  selected={currentView === "company"}
                >
                  Company Setup
                </MenuItem>
              </>
            )}
            {/* <MenuItem
              onClick={() => {
                handleClose();
              }}
            >
              Change Password
            </MenuItem> */}
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
            <Divider />
            <div className="px-4 py-2 text-xs text-gray-500 select-none cursor-default font-normal">
              v{process.env.REACT_APP_VERSION || process.env.npm_package_version || "0.1.0"}
            </div>
          </Menu>
        </div>
      </div>
    </>
  );
}

export default Header;
